import { Controller } from '@hotwired/stimulus'

// Selection toolbar for the work list jobs table. Tracks checked job rows,
// switches between the default and selection toolbars, and drives the
// move-jobs and bulk-cancel modals.
export default class extends Controller {
  static targets = [
    'defaultToolbar',
    'selectionToolbar',
    'selectedCount',
    'moveModal',
    'moveList',
    'moveForm',
    'bulkModal',
    'bulkList',
    'bulkJobIds'
  ]

  connect() {
    this.update()
  }

  change() {
    this.update()
  }

  get selectedJobIds() {
    return Array.from(this.element.querySelectorAll('table.work-list-table input.checkbox:checked'))
      .map((checkbox) => checkbox.dataset.jobId)
      .filter(Boolean)
  }

  get selectedRows() {
    return Array.from(this.element.querySelectorAll('table.work-list-table input.checkbox:checked'))
      .map((checkbox) => checkbox.closest('tr.work-list-job'))
      .filter(Boolean)
  }

  update() {
    const count = this.selectedJobIds.length
    if (this.hasDefaultToolbarTarget) {
      this.defaultToolbarTarget.classList.toggle('hidden', count > 0)
    }
    if (this.hasSelectionToolbarTarget) {
      this.selectionToolbarTarget.classList.toggle('hidden', count === 0)
    }
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = count === 1 ? '1 job selected' : `${count} jobs selected`
    }
  }

  fillList(list) {
    list.innerHTML = ''
    this.selectedRows.forEach((row) => {
      const invoice = row.querySelector('td[data-label="Invoice No."]')?.textContent.trim() || '—'
      const address = row.querySelector('td[data-label="Address"] span.customer-address')?.textContent.trim() || ''
      const item = document.createElement('li')
      item.textContent = `${invoice} · ${address}`
      list.appendChild(item)
    })
  }

  openMove() {
    if (this.selectedJobIds.length === 0) return
    this.fillList(this.moveListTarget)
    this.modalControllerFor(this.moveModalTarget).open()
  }

  openBulk() {
    if (this.selectedJobIds.length === 0) return
    this.fillList(this.bulkListTarget)
    this.bulkJobIdsTarget.value = this.selectedJobIds.join(',')
    this.modalControllerFor(this.bulkModalTarget).open()
  }

  async submitMove(event) {
    event.preventDefault()
    const form = this.moveFormTarget
    const token = this.csrfToken()
    const body = new URLSearchParams({
      authenticity_token: token,
      date: form.querySelector('input[name="date"]').value,
      work_list_category_id: form.querySelector('select[name="work_list_category_id"]').value
    })
    this.selectedJobIds.forEach((id) => body.append('job_ids[]', id))

    const submit = form.querySelector('input[type="submit"]')
    submit.disabled = true
    submit.value = 'Moving...'

    try {
      const response = await fetch(form.action, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': token },
        body
      })
      if (response.ok) {
        window.location.reload()
      } else {
        throw new Error('move jobs failed')
      }
    } catch (error) {
      alert('Could not move jobs')
      submit.disabled = false
      submit.value = 'Move jobs'
    }
  }

  modalControllerFor(element) {
    return this.application.getControllerForElementAndIdentifier(element, 'modal')
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }
}
